import "./topBar.scss";
import UserNotifications from "../../UserNotifications";
import { notificationDTO } from "../../UserNotifications/tenantApiCalls";

export interface NotificationsDialogProps {
    notifications: notificationDTO[];
    onClose: () => void;
    onNotificationClick: () => void;
}

function NotificationsDialog(props: NotificationsDialogProps) {
    return (
        <>
            <div
                className="offClick"
                onClick={props.onClose}
            />
            <div className="user-Alarms-dialog">
                <UserNotifications
                    notifications={props.notifications}
                    onClose={props.onClose}
                    onNotificationClick={props.onNotificationClick}
                />
            </div>
        </>
    );
}

export default NotificationsDialog;
